(() => {
  const form = document.querySelector('.gm-collection-intro-form');
  if (!form) return;

  const button = form.querySelector('[data-gm-collection-intro-cta]');
  const label = form.querySelector('[data-gm-collection-intro-label]');
  const error = form.querySelector('[data-gm-collection-intro-error]');
  const originalLabel = label.textContent;
  let submitting = false;

  function reset() {
    submitting = false;
    button.disabled = false;
    form.removeAttribute('aria-busy');
    label.textContent = originalLabel;
  }

  window.addEventListener('pageshow', reset);

  form.addEventListener('submit', async (event) => {
    if (submitting) {
      event.preventDefault();
      return;
    }
    if (!window.fetch) return;
    event.preventDefault();
    submitting = true;
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding to cart…';
    error.hidden = true;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }] }),
      });
      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result.description || 'Unable to add this carton.');
      }
      const destination = form.elements.return_to.value;
      window.location.assign(destination);
    } catch (cause) {
      error.textContent = `${cause.message || 'We could not confirm the add.'} Check your cart before trying again.`;
      error.hidden = false;
      reset();
    }
  });
})();
